import { createTokenQueryServiceInstance } from 'src/app/core/services/query.service';
import { SignalStoreConfig } from 'src/app/shared/functions/store.functions';
import { QueryState } from 'src/app/core/models/query.model';
import { Psa, PsaType } from './psa.model';


export const FORM_ENDPOINT = 'forms';
export const FORM_QUERY_SERVICE_INSTANCE = createTokenQueryServiceInstance(FORM_ENDPOINT);


export const formStateConfig: SignalStoreConfig<QueryState<any>> = {
  initState: {
    list: []
  }
}
